import React from "react";

const ExistingSectionsList = ({ sections }) => {
  return (
    <div className="pb-card">
      <h2>Existing Sections</h2>

      <div className="pb-list">
        {sections.map((s) => (
          <div className="pb-list-item" key={s.id}>
            <div className="pb-list-title">
              {s.title} <span className="pb-badge">{s.mode}</span>
            </div>
            <div className="pb-list-sub">{s.description || ""}</div>
          </div>
        ))}

        {sections.length === 0 && <div className="pb-muted">No sections yet.</div>}
      </div>
    </div>
  );
};

export default ExistingSectionsList;